export default __webpack_public_path__ + "static/media/OrCalcalist.29515b96.svg";